import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import AddButton from "../../../../components/AddButton";
import {
  CameraAddState,
  CameraSaving,
  SecurityAddState,
  SecurityEditState,
  CameraModalState,
  CameraForEdit,
  securityFromOffice,
  cameraDeactivateModal,
  tempCameras,
  CameraForEditFromOffice,
  RequiredInput,
} from "../atoms/atoms";
import { useGetCamerasByRecordNumber } from "../hooks/useGetCamerasByRecordNumber";
import { ICamera, ISecurityDetails } from "../types";

import { useFieldArray, useFormContext } from "react-hook-form";

import { useCamerasAndLocation } from "../hooks/useCamerasAndLocation";
import { useCameraTypes1 } from "../hooks/useCameraTypes1";
import { useCameraTypes2 } from "../hooks/useCameraTypes2";
import { useDVRTypes } from "../hooks/useDVRTypes";
import { useCameraSystems } from "../hooks/useCameraSystems";
import CameraCard from "../../../../components/CameraCard";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import useAddSingleCamera from "../hooks/useAddSingleCamera";
import { toast } from "../../../../components/toastNotification";
import { useQueryClient } from "react-query";
import useEditSingleCamera from "../hooks/useEditSingleCamera";
import useDeleteCamera from "../hooks/useDeleteCamera";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import moment from "moment";
import SecurityCameraForm from "components/SecurityCameraForm";

interface CameraProps {
  cameras?: Array<ICamera>;
  rowForEdit: ISecurityDetails | undefined;
}
const defaulCamera = [
  {
    parentRow: true,
    tableName: "camera",
    camerasAndLocation: "",
  },
] as Array<ICamera>;

const CameraForm = ({
  rowForEdit,
  cameras = defaulCamera,
}: CameraProps): JSX.Element => {
  const [isShowCameraModal, setShowCameraModal] =
    useRecoilState(CameraAddState);
  const [showCameraCardModal, setShowCameraCardModal] =
    useRecoilState(CameraModalState);
  const [isAddState] = useRecoilState(SecurityAddState);
  const [isEditState] = useRecoilState(SecurityEditState);
  const [isAddInEditState, setIsAddInEditState] = useState(false);
  const [isEditInAddState, setIsEditInAddState] = useState(false);
  const [isSaving, setIsSaving] = useRecoilState(CameraSaving);
  const [showDeactivateModal, setShowDeactivateModal] = useRecoilState(
    cameraDeactivateModal
  );
  const [hasDeletePermission, setHasDeletePermission] = useState(false);
  const userPermissions = useRecoilValue(permissionsSelector);
  const deletePermission = PERMISSIONS.permission_security_delete;
  const addPermission = PERMISSIONS.permission_security_add;
  const [forDeleteDetails, setForDeleteDetails] = useState<ICamera | null>(
    null
  );
  const queryClient = useQueryClient();
  const [hasFirstFieldValue, setHasFirstFieldValue] = useState(true);
  const [clickCount, setClickCount] = useState(0);
  const [cameraForEditData, setCameraForEditData] =
    useRecoilState<any>(CameraForEdit);
  const [showFromOffice] = useRecoilState(securityFromOffice);
  const [forDelete, setForDelete] = useState<any>([]);
  const [forAddCamera, setForAddCamera] = useState<any>([]);
  const [, setIsRequired] = useRecoilState(RequiredInput);
  //#region Form

  const formMethods = useFormContext();

  const {
    register,
    formState: { errors },
    control,
    watch,
    reset,
  } = formMethods;

  //#endregion

  //#region Options
  const { data: camAndLocation } = useCamerasAndLocation();
  const camAndLocationOption = camAndLocation?.data?.map(
    (x: { id: number; camerasAndLocation: string }) => {
      return {
        id: x.id,
        value: x.id?.toString(),
        label: x.camerasAndLocation,
      };
    }
  );

  const { data: camTypes1 } = useCameraTypes1();
  const camTypes1Option = camTypes1?.data?.map(
    (x: { id: number; cameraType1: string }) => {
      return {
        id: x.id,
        value: x.id,
        label: x.cameraType1,
      };
    }
  );

  const { data: camTypes2 } = useCameraTypes2();
  const camTypes2Option = camTypes2?.data?.map(
    (x: { id: number; cameraType2: string }) => {
      return {
        id: x.id,
        value: x.id,
        label: x.cameraType2,
      };
    }
  );

  const { data: DVRTypes } = useDVRTypes();
  const dvrTypesOption = DVRTypes?.data?.map(
    (x: { id: number; dvrtype: string }) => {
      return {
        id: x.id,
        value: x.id,
        label: x.dvrtype,
      };
    }
  );

  const { data: CameraSystems } = useCameraSystems();
  const cameraSystemOption = CameraSystems?.data?.map(
    (x: { id: number; cameraSystem: string }) => {
      return {
        id: x.id,
        value: x.id,
        label: x.cameraSystem,
      };
    }
  );
  //#endregion

  //#region Add/minus of forms
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "camera",
  });

  const tableArray = cameras.length > 0 && watch(`${cameras[0].tableName}`);
  const id = rowForEdit?.recordNumber;
  const controlledFields =
    tableArray &&
    fields.map((field, index) => ({
      ...field,
      ...tableArray[index],
      recordNumber: id,
    }));
  //SETTING DEFAULT TABLE VALUES
  useEffect(() => {
    if (cameras) {
      replace(cameras);
    }
  }, [cameras]);
  //#endregion Add/minus
  //Add Validation

  const [initialAddCameras, setInitialAddCameras] = useRecoilState(tempCameras);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const submitInitialAdd = (buttonState) => {
    if (buttonState === "proceed") {
      const submittedValues = formMethods.getValues();

      const hasCamera =
        submittedValues.camera && submittedValues.camera.length > 0;

      if (!hasCamera) {
        return; // Exit
      }
      const cameraData = submittedValues.camera?.[0] || {};

      const hasMeaningfulData =
        cameraData.cameraMake ||
        cameraData.cameraModel ||
        cameraData.dvrTypeId ||
        cameraData.cameraSystemId ||
        (cameraData.camerasAndLocation &&
          cameraData.camerasAndLocation.length > 0);

      if (!hasMeaningfulData) {
        return;
      }

      //dont save if cameralocationid is empty
      const allLocationsAreValid = submittedValues.camera.every(
        (item) => item.camerasAndLocation && item.camerasAndLocation.length > 0
      );

      if (!allLocationsAreValid) {
        return;
      }
      const topLevelCamera = {
        cameraMake: cameraData.cameraMake,
        cameraModel: cameraData.cameraModel,
        dvrTypeId: cameraData.dvrTypeId,
        dvrRecordingMax: cameraData.dvrRecordingMax,
        cameraInstallDate: cameraData.cameraInstallDate,
        isActive: true,
        cameraSystemId: cameraData.cameraSystemId,
        cameraIpAddress: cameraData.cameraIpAddress,
        ipGateway: cameraData.ipGateway,
        subnetMask: cameraData.subnetMask,
        dns: cameraData.dns,
      };

      const cameraLocationsDto = submittedValues.camera.map((item) => ({
        id: 0,
        cameraId: 0,
        camerasAndLocationId:
          item.camerasAndLocation?.map((loc) => loc.value).join(",") || "",
        cameraType1: item.cameraType1Id ?? null,
        cameraType2: item.cameraType2Id ?? null,
      }));

      const finalDto = {
        ...topLevelCamera,
        cameraLocationsDto,
      };
      setInitialAddCameras((prev) => [...(prev || []), finalDto]);
      setIsRequired(false);
    }
  };

  const checkEmptyFields = (buttonState) => {
    if (buttonState === "add") {
      setClickCount(clickCount + 1);
      watch("camera[0].camerasAndLocation").length > 0
        ? setHasFirstFieldValue(true)
        : setHasFirstFieldValue(false);
    }
    if (buttonState === "proceed") {
      const fieldLen = controlledFields.length;
      let hasValueCount = 0;

      controlledFields.forEach((obj: ICamera, i: number) =>
        Object.entries(obj)?.forEach(([key, value]) => {
          if (key === "camerasAndLocation") {
            if (value && value.length >= 1) {
              hasValueCount = hasValueCount + 1;
              if (fieldLen === hasValueCount) {
                setShowCameraModal(false);
              }

              if (fieldLen === hasValueCount && isEditState) {
                handleEditSave();
              }
            } else {
              setClickCount(clickCount + 1);
              toast.fire(
                "Information",
                "Please fill the camera field to proceed.",
                "info"
              );
              setHasFirstFieldValue(false);
            }
          }
        })
      );
    }
    if (buttonState === "saveEdit") {
      const { isDirty } = formMethods.formState;
      if (!isDirty) {
        toast.fire("Information", "No changes have been made.", "info");
        return;
      }
      const fieldLen = controlledFields.length;
      let hasValueCount = 0;
      controlledFields.forEach((obj: ICamera, i: number) =>
        Object.entries(obj)?.forEach(([key, value]) => {
          if (key === "camerasAndLocation") {
            if (value && value.length >= 1) {
              hasValueCount = hasValueCount + 1;
              if (fieldLen === hasValueCount && isAddInEditState) {
                handleAddSave();
              }
            } else {
              setClickCount(clickCount + 1);
              setIsRequired(true);
              toast.fire(
                "Information",
                "Please fill the camera field to save.",
                "info"
              );
              setHasFirstFieldValue(false);
            }
          }
        })
      );
    }
  };

  useEffect(() => {
    if (clickCount > 0 && !hasFirstFieldValue) {
      setIsRequired(true);
      toast.fire(
        "Information",
        "Please fill the camera field to add new.",
        "info"
      );
    }
  }, [clickCount]);

  const { data: camerasData } = useGetCamerasByRecordNumber(
    rowForEdit ? rowForEdit?.recordNumber : 0
  );

  //Single Add Initialization
  const {
    mutate: addSingleCamera,
    isSuccess: addCameraSuccess,
    data: addCameraResult,
    isError: addCameraError,
    reset: resetAddCameraData,
  } = useAddSingleCamera();

  //Single Edit Initialization
  const {
    mutate: editSingleCamera,
    isSuccess: editCameraSuccess,
    data: editCameraResult,
    isError: editCameraError,
    reset: resetEditCameraData,
  } = useEditSingleCamera();

  //Delete Initialization
  const {
    mutate: deleteCamera,
    isSuccess: deleteCameraSuccess,
    data: deleteCameraResult,
    isError: deleteCameraError,
    reset: resetDeleteCameraData,
  } = useDeleteCamera();

  const resetData = () => {
    formMethods.setValue("camera[0].camerasAndLocation", "");
    formMethods.setValue("camera[0].cameraType1Id", "");
    formMethods.setValue("camera[0].cameraType2Id", "");
    formMethods.setValue("camera[0].cameraMake", "");
    formMethods.setValue("camera[0].cameraInstallDate", "");
    formMethods.setValue("camera[0].cameraModel", "");
    formMethods.setValue("camera[0].dvrTypeId", "");
    formMethods.setValue("camera[0].dvrRecordingMax", "");
    formMethods.setValue("camera[0].cameraSystemId", "");
    formMethods.setValue("camera[0].cameraIpAddress", "");
    formMethods.setValue("camera[0].ipGateway", "");
    formMethods.setValue("camera[0].subnetMask", "");
    formMethods.setValue("camera[0].dns", "");
  };

  const handleAddSave = () => {
    setIsSaving(true);

    if (!controlledFields || controlledFields.length === 0) return;

    const mainCameraData = controlledFields[0];

    const cameraLocationsDto: Array<{
      id: number;
      cameraId: null | number;
      camerasAndLocationId: string;
      cameraType1: number | null;
      cameraType2: number | null;
    }> = [];

    controlledFields.forEach((field) => {
      if (field.camerasAndLocation && field.camerasAndLocation.length > 0) {
        const locationIds = field.camerasAndLocation.map(
          (loc) => loc.id || loc.value || 0
        );

        cameraLocationsDto.push({
          id: 0,
          cameraId: null,
          camerasAndLocationId: locationIds.join(","),
          cameraType1: field.cameraType1Id || null,
          cameraType2: field.cameraType2Id || null,
        });
      }
    });

    const dto = {
      id: 0,
      recordNumber: mainCameraData.recordNumber || 0,
      officeId: mainCameraData.officeId || 1,
      cameraMake: mainCameraData.cameraMake || "",
      cameraModel: mainCameraData.cameraModel || "",
      dvrTypeId: mainCameraData.dvrTypeId || null,
      dvrRecordingMax: mainCameraData.dvrRecordingMax || "",
      cameraInstallDate: mainCameraData.cameraInstallDate || null,
      isActive: true,
      createdBy: "admin",
      cameraSystemId: mainCameraData.cameraSystemId || null,
      cameraType1: mainCameraData.cameraType1 || null,
      cameraType2: mainCameraData.cameraType2 || null,
      dvrType: mainCameraData.dvrType || null,
      cameraSystem: mainCameraData.cameraSystem || null,
      cameraLocationsDto,
      cameraIpAddress: mainCameraData.cameraIpAddress || null,
      ipGateway: mainCameraData.ipGateway || null,
      subnetMask: mainCameraData.subnetMask || null,
      dns: mainCameraData.dns || null,
    };

    addSingleCamera(dto);
    setShowCameraModal(false);
  };

  useEffect(() => {
    if (showFromOffice && showCameraCardModal) {
      reset({ name: [] });
      setEditCameraValues(camerasData);
    }
  }, [showFromOffice]);

  const [cameraForEditFromOfficeData, setCameraForEditFromOfficeData] =
    useRecoilState(CameraForEditFromOffice);

  //Set Edit default values
  const setEditCameraValues = (camera: any[]) => {
    const sourceData =
      cameraForEditFromOfficeData &&
      Array.isArray(cameraForEditFromOfficeData) &&
      cameraForEditFromOfficeData.length > 0
        ? cameraForEditFromOfficeData
        : camera;

    if (!Array.isArray(sourceData) || sourceData.length === 0) return;

    const cam = cameraForEditFromOfficeData || sourceData[0];

    const currentFieldCount = formMethods.getValues("camera")?.length || 0;
    if (currentFieldCount > 0) {
      for (let i = currentFieldCount - 1; i >= 0; i--) {
        remove(i);
      }
    }

    const groupedRows: {
      cameraType1: number | null;
      cameraType2: number | null;
      camerasAndLocationIds: string[];
    }[] = [];

    cam.cameraLocationsDto.forEach((loc) => {
      const ids = loc.camerasAndLocationId?.split(",") || [];
      groupedRows.push({
        cameraType1: loc.cameraType1 ?? null,
        cameraType2: loc.cameraType2 ?? null,
        camerasAndLocationIds: ids,
      });
    });

    groupedRows.forEach((group, index) => {
      append({ tableName: cam?.tableName, parentRow: false });

      const cameraLocationValues = group.camerasAndLocationIds
        .map((id) =>
          camAndLocationOption?.find((opt) => String(opt.value) === String(id))
        )
        .filter(Boolean);

      formMethods.setValue(
        `camera.${index}.camerasAndLocation`,
        cameraLocationValues.length > 0 ? cameraLocationValues : null
      );
      formMethods.setValue(`camera.${index}.cameraType1Id`, group.cameraType1);
      formMethods.setValue(`camera.${index}.cameraType2Id`, group.cameraType2);
    });

    formMethods.setValue("cameraMake", cam.cameraMake);
    formMethods.setValue("cameraModel", cam.cameraModel);
    formMethods.setValue(
      "cameraInstallDate",
      cam.cameraInstallDate?.slice(0, 10) || ""
    );
    formMethods.setValue("dvrTypeId", cam.dvrTypeId);
    formMethods.setValue("dvrRecordingMax", cam.dvrRecordingMax);
    formMethods.setValue("cameraSystemId", cam.cameraSystemId);
    formMethods.setValue("isActive", cam.isActive);
    formMethods.setValue("createdBy", cam.createdBy);
    formMethods.setValue("createdDate", cam.createdDate);
    formMethods.setValue("cameraIpAddress", cam.cameraIpAddress);
    formMethods.setValue("ipGateway", cam.ipGateway);
    formMethods.setValue("subnetMask", cam.subnetMask);
    formMethods.setValue("dns", cam.dns);

    queryClient.invalidateQueries("GetCamerasByRecordNumber");
    setShowCameraCardModal(true);
  };

  const RemoveCamera = (id: any) => {
    let newDataObj = forDelete;
    newDataObj.push(id);
  };

  const handleEditSave = () => {
    const values = formMethods.getValues();

    const cameraLocationsDto = values.camera.map((cam) => {
      return {
        cameraId: id,
        camerasAndLocationId:
          cam.camerasAndLocation?.map((loc) => loc.value).join(",") || null,
        cameraType1: cam.cameraType1Id || null,
        cameraType2: cam.cameraType2Id || null,
      };
    });

    const payload: any = {
      id: cameraForEditData?.id,
      recordNumber: rowForEdit?.recordNumber,
      officeId: rowForEdit?.officeId ?? 0,
      cameraMake: formMethods.getValues("cameraMake"),
      cameraModel: formMethods.getValues("cameraModel"),
      dvrTypeId: formMethods.getValues("dvrTypeId"),
      dvrRecordingMax: formMethods.getValues("dvrRecordingMax"),
      cameraInstallDate: formMethods.getValues("cameraInstallDate")
        ? formMethods.getValues("cameraInstallDate").slice(0, 10)
        : null,
      isActive: formMethods.getValues("isActive"),
      createdBy: formMethods.getValues("createdBy"),
      cameraSystemId: formMethods.getValues("cameraSystemId"),
      cameraType1: null,
      cameraType2: null,
      dvrType: null,
      cameraSystem: null,
      cameraLocationsDto: cameraLocationsDto,
      cameraIpAddress: formMethods.getValues("cameraIpAddress"),
      ipGateway: formMethods.getValues("ipGateway"),
      subnetMask: formMethods.getValues("subnetMask"),
      dns: formMethods.getValues("dns"),
    };

    const hasInvalidCameraId = payload.cameraLocationsDto.some(
      (location) =>
        !location.camerasAndLocationId || location.camerasAndLocationId === 0
    );

    if (hasInvalidCameraId) {
      toast.fire(
        "Information",
        "Please fill the camera field to save.",
        "info"
      );
      setIsRequired(true);
      return;
    }

    //isdirty checker
    const normalizeDate = (dateString) => {
      if (!dateString) return null;
      return dateString.slice(0, 10);
    };

    const getComparableData = (data) => {
      const excludedFields = [
        "id",
        "recordNumber",
        "officeId",
        "createdBy",
        "createdDate",
        "modifiedBy",
        "modifiedDate",
        "dvrType",
        "cameraSystem",
        "officeBrand",
        "officeStatus",
        "officeState",
        "officeName",
      ];

      const filtered = Object.keys(data)
        .filter((key) => !excludedFields.includes(key))
        .reduce((obj, key) => {
          if (key === "cameraLocationsDto" && Array.isArray(data[key])) {
            obj[key] = data[key].map((location) => {
              const { id, cameraId, ...rest } = location;
              return rest;
            });
          } else if (key === "cameraInstallDate") {
            obj[key] = normalizeDate(data[key]);
          } else {
            obj[key] = data[key];
          }
          return obj;
        }, {});

      return filtered;
    };

    const comparableNewData = getComparableData(payload);
    const comparableOldData = getComparableData(cameraForEditData);

    const newData = JSON.stringify(comparableNewData);
    const oldData = JSON.stringify(comparableOldData);

    if (newData === oldData && forAddCamera?.length === 0) {
      toast.fire("Saving Failed", "No changes have been made.", "warning");
      setIsSaving(false);
    } else {
      setIsSaving(true);

      editSingleCamera(payload);

      if (cameraForEditFromOfficeData) {
        setCameraForEditFromOfficeData(payload);
      }

      setShowCameraCardModal(true);
      setForAddCamera([]);
      setForDelete([]);
    }
  };

  //Deactivate
  const handleDeactivate = () => {
    const payload = {
      id: forDeleteDetails?.id,
      recordNumber: forDeleteDetails?.recordNumber,
    } as ICamera;

    deleteCamera(payload, {
      onSuccess: () => {
        toast.fire("Success", "Camera deactivated successfully!", "success");

        setShowDeactivateModal(false);
      },
      onError: () => {
        toast.fire("Failed", "Camera deactivation failed!", "error");
      },
    });
  };

  //Modal Messages
  const deleteMessage = (
    <div className="text-gray-500 font-normal">
      {"Are you sure you want to deactivate this Camera?"}
    </div>
  );

  const removeMessage = (
    <div className="text-gray-500 font-normal">
      {"Are you sure you want to remove this Camera?"}
    </div>
  );

  //Toasters
  // Add Success
  if (addCameraSuccess && addCameraResult) {
    if (addCameraResult.status === 201 || addCameraResult.status === 200) {
      toast.fire("Success", "Camera added successfully.", "success");
      queryClient.invalidateQueries("GetCamerasByRecordNumber");
      setIsSaving(false);
      resetAddCameraData();
      resetData();
    }
  }
  if (addCameraError) {
    toast.fire(
      "Adding Camera failed",
      "Camera details already exists",
      "error"
    );
    setIsSaving(false);
    resetAddCameraData();
  }

  if (editCameraError) {
    toast.fire("Edit Camera failed", "Camera details already exists", "error");
    setIsSaving(false);
    resetEditCameraData();
    setShowCameraCardModal(false);
  }
  // Edit Success
  if (editCameraSuccess && editCameraResult) {
    if (editCameraResult.status === 201 || editCameraResult.status === 200) {
      toast.fire("Success", "Camera updated successfully.", "success");
      queryClient.invalidateQueries("GetCamerasByRecordNumber");
      setShowCameraCardModal(false);
      setForAddCamera([]);
      setForDelete([]);
      setIsSaving(false);
      resetEditCameraData();
    }
  }

  // Delete Success
  if (deleteCameraSuccess && deleteCameraResult) {
    if (
      deleteCameraResult.status === 201 ||
      deleteCameraResult.status === 200
    ) {
      toast.fire("Success", "Camera deactivated successfully.", "success");
      queryClient.invalidateQueries("GetCamerasByRecordNumber");
    }
    resetDeleteCameraData();
  }

  useEffect(() => {
    if (userPermissions.includes(deletePermission)) {
      setHasDeletePermission(true);
    }
  }, []);

  //// reset form used in adding
  const resetCameraForm = () => {
    remove();
    append({
      tableName: cameras[0]?.tableName,
      parentRow: true,
      cameraMake: "",
      cameraModel: "",
      cameraInstallDate: null,
      dvrTypeId: null,
      dvrRecordingMax: "",
      cameraSystemId: null,
      camerasAndLocation: [],
      cameraType1Id: null,
      cameraType2Id: null,
    });

    setCameraForEditData(null);
    setEditCameraValues([]);
  };

  //removing of array in initial add
  const [indexToRemove, setIndexToRemove] = useState<number | null>(null);
  const [showRemoveModal, setShowRemoveModal] = useState(false);

  const handleRemove = () => {
    if (indexToRemove !== null) {
      setInitialAddCameras((prevData) =>
        prevData.filter((_, i) => i !== indexToRemove)
      );
      setIndexToRemove(null);
    }
    setShowRemoveModal(false);
  };
  const handleOpenCardModalRemove = (index) => {
    setIndexToRemove(index);
    setShowRemoveModal(true);
  };

  // edit function for initial add
  const handleEditInAdd = () => {
    const formData = formMethods.getValues();

    const payload = {
      cameraMake: formData.cameraMake,
      cameraModel: formData.cameraModel,
      dvrTypeId: formData.dvrTypeId,
      dvrRecordingMax: formData.dvrRecordingMax,
      cameraInstallDate: formData.cameraInstallDate
        ? moment.utc(formData.cameraInstallDate).format("YYYY-MM-DD")
        : null,

      isActive: formData.isActive,
      cameraSystemId: formData.cameraSystemId,
      cameraIpAddress: formData.cameraIpAddress,
      ipGateway: formData.ipGateway,
      subnetMask: formData.subnetMask,
      dns: formData.dns,
      cameraLocationsDto: (formData.camera || []).map((item) => {
        const camerasAndLocationId = item.camerasAndLocation
          ?.map((loc) => loc.value)
          .join(",");

        return {
          id: item.id ?? 0,
          cameraId: 0,
          camerasAndLocationId: camerasAndLocationId || null,
          cameraType1: item.cameraType1Id,
          cameraType2: item.cameraType2Id,
        };
      }),
    };

    const hasInvalidCameraId = payload.cameraLocationsDto.some(
      (location) =>
        !location.camerasAndLocationId || location.camerasAndLocationId === 0
    );

    if (hasInvalidCameraId) {
      setIsRequired(true);
      toast.fire(
        "Information",
        "Please fill the camera field to proceed.",
        "info"
      );
      return;
    }

    if (editingIndex !== null) {
      const updatedList = [...initialAddCameras];
      updatedList[editingIndex] = payload;
      setInitialAddCameras(updatedList);
      setEditingIndex(null); // Reset
      setIsEditInAddState(false); // Reset edit state
      setShowCameraCardModal(false);
    } else {
      console.log("No index ");
    }
  };

  return (
    <div className="mx-2 mt-2 bg-white box-shadow rounded-lg h-full">
      <div className="flex flex-row justify-between py-2">
        <div className="text-quinary font-bold font-sans px-4">
          Camera Section
        </div>
        {userPermissions.includes(addPermission) ? (
          camerasData?.length < 10 ? (
            <div className="py-2 px-4">
              <AddButton
                className="opacity-100"
                disabled={false}
                buttonText="Add Camera"
                onClick={() => {
                  setShowCameraModal(true);
                  setIsAddInEditState(true);
                  resetCameraForm();
                  setIsRequired(false);
                }}
              />
            </div>
          ) : (
            <div className="py-2 pt-8"></div>
          )
        ) : (
          <div className="py-2 pt-8"></div>
        )}
      </div>
      {isAddState && (
        <div className="text-quinary font-bold font-sans py-2 px-4  grid grid-cols-5 gap-x-4">
          {Array.isArray(initialAddCameras) && initialAddCameras.length > 0 ? (
            initialAddCameras.map((camera, index) => (
              <CameraCard
                key={index}
                camera={camera}
                isEditState={true}
                camAndLocation={camAndLocation}
                hasDeletePermission={hasDeletePermission}
                onClickView={() => {}}
                onClickEdit={() => {
                  setEditCameraValues([camera]);
                  setCameraForEditData(camera);
                  setEditingIndex(index);
                  setIsEditInAddState(true);
                  setIsRequired(false);
                }}
                onClickDelete={() => {
                  setShowDeactivateModal(true);
                }}
                hideDelete
                onClickRemove={() => {
                  handleOpenCardModalRemove(index);
                }}
                hideRemove={
                  (indexToRemove !== null && index === indexToRemove) ||
                  showCameraCardModal
                }
                editHidden={
                  (indexToRemove !== null && index === indexToRemove) ||
                  showCameraCardModal
                }
              />
            ))
          ) : (
            <div></div>
          )}
        </div>
      )}

      {/* Show card edit button if edit state*/}
      {isEditState && (
        <div className="w-full borderContainer -mt-4 pb-4 bg-white px-4">
          <div className="grid gap-2 grid-cols-5 bg-red">
            {/* Card */}

            {Array.isArray(camerasData) && camerasData.length > 0 ? (
              camerasData.map((camera, index) => {
                return (
                  <CameraCard
                    key={camera.id ?? index}
                    camera={camera}
                    isEditState={isEditState}
                    camAndLocation={camAndLocation}
                    hasDeletePermission={hasDeletePermission}
                    onClickView={() => {}}
                    onClickEdit={() => {
                      setEditCameraValues([camera]);
                      setCameraForEditData(camera);
                      setIsRequired(false);
                    }}
                    onClickDelete={() => {
                      setShowDeactivateModal(true);
                      setForDeleteDetails(camera);
                    }}
                    hideDelete={showCameraCardModal}
                    editHidden={showCameraCardModal}
                    hideRemove
                  />
                );
              })
            ) : (
              <div></div>
            )}
          </div>
        </div>
      )}

      {isShowCameraModal && (
        <SecurityCameraForm
          isOpen={isShowCameraModal}
          onClose={() => setShowCameraModal(false)}
          mode={isAddState ? "initialAdd" : "add"}
          isSaving={isSaving}
          formMethods={formMethods}
          controlledFields={controlledFields}
          append={append}
          remove={remove}
          onSubmit={() => {
            if (isAddState) {
              submitInitialAdd("proceed");
              checkEmptyFields("proceed");
            } else {
              checkEmptyFields("saveEdit");
            }
          }}
          checkEmptyFields={checkEmptyFields}
          RemoveCamera={RemoveCamera}
          resetData={resetData}
          setCameraForEditFromOfficeData={setCameraForEditFromOfficeData}
          // Options
          dvrTypesOption={dvrTypesOption}
          cameraSystemOption={cameraSystemOption}
          camAndLocationOption={camAndLocationOption}
          camTypes1Option={camTypes1Option}
          camTypes2Option={camTypes2Option}
          // State
          cameras={cameras}
          hasDeletePermission={hasDeletePermission}
          isEditState={isEditState}
          isAddState={isAddState}
          isAddInEditState={isAddInEditState}
          isEditInAddState={isEditInAddState}
          watch={formMethods.watch}
          setHasFirstFieldValue={setHasFirstFieldValue}
          setShowCameraModal={setShowCameraModal}
          setShowCameraCardModal={setShowCameraCardModal}
        />
      )}

      {/* Edit Camera Form */}
      {showCameraCardModal && (
        <SecurityCameraForm
          isOpen={showCameraCardModal}
          onClose={() => setShowCameraCardModal(false)}
          mode={isEditInAddState ? "initialEdit" : "edit"}
          isSaving={isSaving}
          formMethods={formMethods}
          controlledFields={controlledFields}
          append={append}
          remove={remove}
          checkEmptyFields={checkEmptyFields}
          onSubmit={() => {
            if (isEditInAddState) {
              handleEditInAdd();
            } else {
              handleEditSave();
            }
          }}
          RemoveCamera={RemoveCamera}
          resetData={resetData}
          setCameraForEditFromOfficeData={setCameraForEditFromOfficeData}
          // Options
          dvrTypesOption={dvrTypesOption}
          cameraSystemOption={cameraSystemOption}
          camAndLocationOption={camAndLocationOption}
          camTypes1Option={camTypes1Option}
          camTypes2Option={camTypes2Option}
          // State
          cameras={cameras}
          hasDeletePermission={hasDeletePermission}
          isEditState={isEditState}
          isAddState={isAddState}
          isAddInEditState={isAddInEditState}
          isEditInAddState={isEditInAddState}
          watch={formMethods.watch}
          setHasFirstFieldValue={setHasFirstFieldValue}
          setShowCameraModal={setShowCameraModal}
          setShowCameraCardModal={setShowCameraCardModal}
        />
      )}
      {/* Deactivate Modal */}
      {showDeactivateModal && (
        <ConfirmBoxDelete
          ModalTitle="Security Camera"
          qConfirmation={deleteMessage}
          isOpen={showDeactivateModal}
          onClose={() => setShowDeactivateModal(false)}
          onClickFunction={() => handleDeactivate()}
          cancelButtonRef={undefined}
        />
      )}

      {showRemoveModal && (
        <ConfirmBoxDelete
          ModalTitle="Camera"
          qConfirmation={removeMessage}
          isOpen={showRemoveModal}
          onClose={() => {
            setShowRemoveModal(false);
            setIndexToRemove(null);
          }}
          onClickFunction={handleRemove}
          cancelButtonRef={undefined}
        />
      )}
    </div>
  );
};

export default CameraForm;
